// src/App.js
import React, { useState } from 'react';
import HomePage from './HomePage';
import TrainInfo from './TrainInfo';
import StationInfo from './StationInfo';
import BikeInfo from './BikeInfo';
import CacheIndicator from './components/CacheIndicator';
import './App.css';
import './BikeInfo.css';

function App() {
  const [viewMode, setViewMode] = useState('home');
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleSelectMode = (mode) => {
    if (mode === viewMode) return;
    
    setIsTransitioning(true);
    
    // 短暫延遲以允許退出動畫
    setTimeout(() => {
      setViewMode(mode);
      setIsTransitioning(false);
    }, 300);
  };

  const handleBackToHome = () => {
    handleSelectMode('home');
  };

  return (
    <div className="app">
      <div className={`container ${isTransitioning ? 'fade-out' : 'fade-in'}`}>
        {viewMode === 'home' && <HomePage onSelectMode={handleSelectMode} />}
        {viewMode !== 'home' && (
          <div className="header">
            <h2>
              {viewMode === 'train' && '🚄 車輛動態查詢'}
              {viewMode === 'station' && '🚉 車站資訊查詢'}
              {viewMode === 'bike' && '🚲 公共自行車查詢'}
            </h2>
            <button className="back-button" onClick={handleBackToHome}>
              返回首頁
            </button>
          </div>
        )}
        {viewMode === 'train' && <TrainInfo />}
        {viewMode === 'station' && <StationInfo />}
        {viewMode === 'bike' && <BikeInfo />}
      </div>
      <CacheIndicator />
    </div>
  );
}

export default App;